module.exports = __webpack_public_path__ + "media/styles/images/svg/check-white-6b3b6af182679e3067194555bf7b343c.svg";